<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Application</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Name</label>
          <input class="form-control" [(ngModel)]="name" placeholder="Tarot" type="text">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
